import NoData from 'components/content/NoData';

interface TextOrNoDataProps {
    value?: unknown;
    className?: string;
}

const TextOrNoData = ({ value, className }: TextOrNoDataProps) =>
    value ? String(value) : <NoData text='No data' className={className} />;

export default TextOrNoData;
